import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as routerStore from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'environments/environment.prod';
import { CookieService } from 'ngx-cookie-service';

import { AppLayoutModule } from './app-layout/app-layout.module';
import { AppRoutingModule, routedComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppStateKey } from './core/app-config/constants/app-state-key.constant';
import { CoreModule } from './core/core.module';
import { FeatureControlModule } from './core/feature-control';
import { DefaultHttpOptionsInterceptor } from './core/http';
import { RouterStateUrlSerializer } from './core/router-state-url-serializer';
import { LoginModule } from './login/login.module';
import { SSOLandingPageModule } from './sso-landing-page/sso-landing-page.module';
import { MaterialModule } from './material.module';
/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders: any[] = [
  { provide: HTTP_INTERCEPTORS, useClass: DefaultHttpOptionsInterceptor, multi: true },
];

export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '/api/language-strings/', '');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    StoreDevtoolsModule.instrument({
      name: 'CZ DevTools',
      logOnly: environment.production,
    }),
    StoreModule.forFeature('router', routerStore.routerReducer),
    routerStore.StoreRouterConnectingModule.forRoot({ stateKey: AppStateKey.router }),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpModule,
    CoreModule.forRoot(), // NOTE: Logging service provider is determined in this static method.
    CoreModule,
    FeatureControlModule,
    AppLayoutModule,
    LoginModule,
    SSOLandingPageModule,
    MaterialModule,
    AppRoutingModule, // Adding this last so wildcard route match is the last entry in merged route configuration
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    routedComponents,
  ],
  providers: [
    {
      provide: routerStore.RouterStateSerializer,
      useClass: RouterStateUrlSerializer,
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-us',
    },
    httpInterceptorProviders,
    CookieService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
